module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-bf98c0b8.png";